module.exports = __webpack_public_path__ + "fonts/iconfont.cc4bc66f.ttf";